import * as types from '../actions/actionTypes';

const defaultState = {
  timeoutId: null,
  showing: false,
  data: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.HIDE_MESSAGE:
      return { ...state, timeoutId: null, showing: false };
    case types.SHOW_MESSAGE:
      return { ...state, timeoutId: action.payload.timeoutId, showing: true, data: action.payload };
    default:
      return defaultState;
  }
};
